import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { authAPI } from '../services/api';
import { toast } from 'sonner';
import './Auth.css';

const ResetPassword = () => {
    const { resetToken } = useParams();
    const navigate = useNavigate();
    const { register, handleSubmit, watch, formState: { errors } } = useForm();
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const password = watch('password');

    const onSubmit = async (data) => {
        setLoading(true);
        try {
            await authAPI.resetPassword(resetToken, { password: data.password });
            toast.success('Password reset successful! Please login with your new password.');
            navigate('/login');
        } catch (error) {
            toast.error(error.response?.data?.message || 'Token invalid or expired');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-container">
            <div className="login-left">
                <div className="illustration-section">
                    <img
                        src="https://images.unsplash.com/photo-1552664730-d307ca884978?w=600&h=800&fit=crop"
                        alt="Team collaboration"
                        className="hero-image"
                    />
                    <div className="image-overlay">
                        <h3 className="illustration-title">Secure Your Account</h3>
                        <p className="illustration-text">Create a strong, unique password to keep your data safe.</p>
                    </div>
                </div>
            </div>
            <div className="login-right">
                <div className="login-card">
                    <div className="login-header">
                        <div className="login-logo">TM</div>
                        <h2 className="login-title">Reset Password</h2>
                        <p className="login-subtitle">Enter your new password below</p>
                    </div>

                    <form onSubmit={handleSubmit(onSubmit)} className="login-form">
                        <div className="form-group">
                            <label className="form-label">New Password</label>
                            <div className="password-input-wrapper">
                                <input
                                    type={showPassword ? 'text' : 'password'}
                                    {...register('password', {
                                        required: 'Password is required',
                                        minLength: { value: 6, message: 'Password must be at least 6 characters' }
                                    })}
                                    className="form-input"
                                    placeholder="Enter new password"
                                    disabled={loading}
                                />
                                <button
                                    type="button"
                                    className="password-toggle"
                                    onClick={() => setShowPassword(!showPassword)}
                                    disabled={loading}
                                >
                                    {showPassword ? 'Hide' : 'Show'}
                                </button>
                            </div>
                            {errors.password && <span className="error-text">{errors.password.message}</span>}
                        </div>

                        <div className="form-group">
                            <label className="form-label">Confirm Password</label>
                            <input
                                type="password"
                                {...register('confirmPassword', {
                                    required: 'Please confirm your password',
                                    validate: value => value === password || 'Passwords do not match'
                                })}
                                className="form-input"
                                placeholder="Confirm new password"
                                disabled={loading}
                            />
                            {errors.confirmPassword && <span className="error-text">{errors.confirmPassword.message}</span>}
                        </div>

                        <button type="submit" className="login-button" disabled={loading}>
                            {loading ? 'Resetting...' : 'Reset Password'}
                        </button>
                    </form>

                    <div className="auth-footer">
                        <Link to="/login" className="link">Back to Sign in</Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResetPassword;
